import { Trip } from "@fairfleet/geotab";
import Skeleton from "@mui/material/Skeleton";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useUserById } from "@/hooks/users/useUserById";
import { getUserEmail } from "@/utilities/user/getUserEmail";

export function DriverEmailCell({ props }: { props: GridRenderCellParams<Trip> }) {
  const driverId = props.row?.driver?.id;
  const { data: driver, isLoading } = useUserById(driverId);

  if (!driver) {
    return <></>;
  }

  if (isLoading || !driver) {
    return <Skeleton width="100%" variant="text" />;
  }

  return <>{getUserEmail(driver)}</>;
}
